[
  {
    "Name": "Janakpur",
    "Nepali": "जनकपुरधाम",
    "District": "Dhanusha",
    "Province": "Province No. 2",
    "Population_2011": "159,468",
    "Area_km2": "91.97"
  },
  {
    "Name": "Ghorahi",
    "Nepali": "घोराही",
    "District": "Dang",
    "Province": "Province No. 5",
    "Population_2011": "156,164",
    "Area_km2": "522.21"
  },
  {
    "Name": "Hetauda",
    "Nepali": "हेटौडा",
    "District": "Makawanpur",
    "Province": "Province No. 3",
    "Population_2011": "152,875",
    "Area_km2": "261.59"
  },
  {
    "Name": "Dhangadhi",
    "Nepali": "धनगढी",
    "District": "Kailali",
    "Province": "Sudurpashchim",
    "Population_2011": "147,741",
    "Area_km2": "261.75"
  },
  {
    "Name": "Tulsipur",
    "Nepali": "तुल्सिपुर",
    "District": "Dang",
    "Province": "Province No. 5",
    "Population_2011": "141,528",
    "Area_km2": "384.63"
  },
  {
    "Name": "Itahari",
    "Nepali": "ईटहरी",
    "District": "Sunsari",
    "Province": "Province No. 1",
    "Population_2011": "140,517",
    "Area_km2": "93.78"
  },
  {
    "Name": "Nepalgunj",
    "Nepali": "नेपालगंज",
    "District": "Banke",
    "Province": "Province No. 5",
    "Population_2011": "138,951",
    "Area_km2": "85.94"
  },
  {
    "Name": "Butwal",
    "Nepali": "बुटवल",
    "District": "Rupandehi",
    "Province": "Province No. 5",
    "Population_2011": "138,741",
    "Area_km2": "101.61"
  },
  {
    "Name": "Dharan",
    "Nepali": "धरान",
    "District": "Sunsari",
    "Province": "Province No. 1",
    "Population_2011": "137,705",
    "Area_km2": "192.32"
  },
  {
    "Name": "Kalaiya",
    "Nepali": "कलैया",
    "District": "Bara",
    "Province": "Province No. 2",
    "Population_2011": "123,659",
    "Area_km2": "108.94"
  },
  {
    "Name": "Jitpur Simara",
    "Nepali": "जीतपुरसिमरा",
    "District": "Bara",
    "Province": "Province No. 2",
    "Population_2011": "117,496",
    "Area_km2": "312.18"
  }
]
